import { VStack } from "@chakra-ui/react";
import { useState } from "react";
import { useNavigationBlockerContext } from "src/components/NavigationBlocker";
import { SegmentedControl } from "src/components/SegmentedControl";
import { useEnrollmentPeriodContext } from "../Edit";
import { OfferingCategoriesPanel } from "./components/OfferingCategoriesPanel";
import { OfferingsPanel } from "./components/OfferingsPanel";
import { EnrollmentSchoolsGradesView } from "./EnrollmentSchoolsGradesView";

export const EnrollmentSchoolsTab: React.FC = () => {
  const { enrollmentPeriod } = useEnrollmentPeriodContext();

  if (enrollmentPeriod.use_service_offerings) {
    return <EnrollmentSchoolsOfferingsView />;
  }

  return <EnrollmentSchoolsGradesView />;
};

enum OfferingsViewMode {
  Categories = "categories",
  Offerings = "offerings",
}

const EnrollmentSchoolsOfferingsView: React.FC = () => {
  const { confirm, hasChanges } = useNavigationBlockerContext();
  const [view, setView] = useState<OfferingsViewMode>(
    OfferingsViewMode.Categories
  );

  const handleViewChange = async (nextView: OfferingsViewMode) => {
    if (nextView === view) return;
    if (hasChanges && !(await confirm())) return;
    setView(nextView);
  };

  return (
    <VStack align="stretch" gap={4}>
      <SegmentedControl
        options={[
          {
            label: "Offering categories",
            value: OfferingsViewMode.Categories,
          },
          {
            label: "Offerings",
            value: OfferingsViewMode.Offerings,
          },
        ]}
        value={view}
        onChange={handleViewChange}
      />
      {view === OfferingsViewMode.Categories ? (
        <OfferingCategoriesPanel />
      ) : (
        <OfferingsPanel
          onGoToOfferingCategories={() => setView(OfferingsViewMode.Categories)}
        />
      )}
    </VStack>
  );
};
